import React, { useEffect, useState } from 'react';
import Reaptcha from 'reaptcha';
import api from '~/services/api';
import ReactTooltip from "react-tooltip";
import {
    ButtonPadraoPrimary,
    InputRadio,
    Form,
    Input,
    GroupInLine,
    ContainerLine,
    Span,
    SpanErrorForm,
    Button,
    Select,
    TextArea
} from '~/styles/CommonStyles';
import Toastify from "~/components/Toastify";

import { Container, Perguntas, Pergunta, Aviso, BtnOpcaoResposta, ContainerBtnsResposta, textareaOpcaoResposta } from './stylesQualidadeVida';
import getUrlParameter from '~/helpers/getURLencode';
import { useRecoilState } from 'recoil';
import { mensagemConformidadeLGPD } from '../../atoms/conformidade';

function QualidadeVida ( { location } ) {
    const params = new URLSearchParams( location.search );
    const _CHAVE = params.get( 'chave' );
    const [ perguntas, setPerguntas ] = useState( [] );
    const [ recaptchaToken, setRecaptchaToken ] = useState( null );
    const [ conformidadeMensagem, setConformidadeMensagem ] = useRecoilState( mensagemConformidadeLGPD );

    useEffect( () => {
        if ( !_CHAVE )
            return Toastify.error( 'Erro, chave ou questionario inexistente, por favor entre em contato com medico para que seja enviado um novo link' );
    }, [ recaptchaToken ] );


    useEffect( () => {
        setConformidadeMensagem( { popUpOpen: true } );
        getQuestionarioPerguntas();
    }, [] );

    async function getQuestionarioPerguntas () {
        try {
            let perquntas = await api.get( 'apoio/getwhoqol' );
            setPerguntas( perquntas.data.map( pergunta => ( { pergunta, Resposta: null } ) ) );

        } catch ( error ) {
            Toastify.error( 'Erro, ' );
            console.log( error );
        }
    };

    function setValor ( index, obj ) {
        let newPerguntas = perguntas.map( ( pergunta, perguntaIndex ) => index == perguntaIndex ? { ...obj } : pergunta );
        setPerguntas( newPerguntas );
    };

    async function salvarRespostas () {
        try {

            if ( !_CHAVE )
                return Toastify.error( 'Por favor, peça que seu medico te envie outro link para respoder o questionario. ' );
            if ( !recaptchaToken )
                return Toastify.warning( 'Por favor, faça a verificação do "captcha" ' );


            let respostas = perguntas.filter( pergunta => pergunta.Resposta !== null );
            respostas = respostas.map( pergunta => pergunta.Resposta + 1 );

            if ( respostas.length + 1 < perguntas.length )
                return Toastify.warning( ' Por favor, responda todas as perguntas. ' );

            let obj = {
                Resultados: [ ...respostas ],
                Chave: _CHAVE,
                responsecaptcha: recaptchaToken,
            };
            let { data } = await api.post( `/apoio/saveWHOQOL`, obj );

            Toastify.success( 'Resposta enviadas com sucesso' );
            return data;
        } catch ( error ) {
            console.log( error );
            Toastify.error( 'Erro ao salvar dados, por favor entre em contato com seu médico' );
            return Promise.reject( error );;
        }
    };

    return (
        <Container>
            <Aviso>
                Por favor responda as perguntas abaixo desse questionário.
                Esse questionário tem um total de { perguntas.length } perguntas, faltando responder
                <b style={ { color: 'red', marginLeft: '3px' } }>{ perguntas.filter( pergunta => pergunta.Resposta == null ).length }</b> perguntas.
            </Aviso>
            <Perguntas>
                { perguntas.map( ( pergunta, indexPegunta ) => {
                    return (
                        <Pergunta key={ indexPegunta } respondida={ pergunta.Resposta != null }>
                            <span>{ pergunta.pergunta }</span>
                            <article style={ { display: 'flex', justifyContent: 'center', width: '100%' } }>
                                <ContainerBtnsResposta >
                                    { tipoPergunta( indexPegunta ).map( ( textoPergunta, i ) => {
                                        return <BtnOpcaoResposta key={ i } selected={ pergunta.Resposta == i } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: i } ) }>{ textoPergunta }</BtnOpcaoResposta>;
                                    } ) }
                                </ContainerBtnsResposta>
                            </article>
                        </Pergunta>
                    );
                } ) }
                <div style={ { display: 'flex', justifyContent: 'center', margin: '10px 0px' } }>
                    <Reaptcha
                        sitekey="6LfrDqgZAAAAABATEykmT5tqdYVnvx0B7Fm3Ahj3"
                        onVerify={ ( value ) => setRecaptchaToken( value ) }
                        onExpire={ () => setRecaptchaToken( null ) }
                    />

                </div>
                <div style={ { display: 'flex', justifyContent: 'center', margin: '0px 0px 10px 0px' } }>

                    <a data-tip data-for='btnHome' >
                        <ButtonPadraoPrimary disabled={ !recaptchaToken } onClick={ () => salvarRespostas() } >Enviar Respostas</ButtonPadraoPrimary>
                    </a>
                    <ReactTooltip delayShow={ 300 } id='btnHome' place="bottom" type="dark" effect="solid">
                        { recaptchaToken ? <span>Enviar Respostas</span> : <span>Antes selecione o captcha de verificação (Não sou o robô)</span> }
                    </ReactTooltip>

                </div>
            </Perguntas>
        </Container>
    );
}

export default QualidadeVida;

function tipoPergunta ( indexPegunta ) {
    if ( indexPegunta == 0 ) {
        return [ "Muito ruim",
            "Ruim",
            "Nem boa nem ruim",
            "Boa",
            "Muito boa", ];

    } else if ( indexPegunta == 1 ) {
        return [ "Muito insatisfeito",
            "Insatisfeiro",
            "Nem insatisfeito nem satisfeito",
            "Satisfeito",
            "Muito satisfeito", ];
    } else if ( indexPegunta >= 2 && indexPegunta <= 8 ) {
        return [ "Nada",
            "Muito pouco",
            "Mais ou menos",
            "Bastante",
            "Extremamente", ];
    } else if ( indexPegunta >= 9 && indexPegunta <= 13 ) {
        return [ "Nada",
            "Muito pouco",
            "Médio",
            "Muito",
            "Completamente", ];
    } else if ( indexPegunta >= 14 && indexPegunta <= 24 ) {

        return [ "Muito ruim",
            "Ruim",
            "Nem bom nem ruim",
            "Bom",
            "Muito bom", ];
    } else {
        return [ "Nunca",
            "Algumas vezes",
            "Frequentemente",
            "Muito frequentemente",
            "Sempre", ];
    }
}
